import * as React from "react";
import ReactDOM from "react-dom/client";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  CategoryScale,
  LogarithmicScale,
  Colors,
  BarElement,
} from "chart.js";
import "@materializecss/materialize/dist/css/materialize.css";
import { Button, Navbar, Pagination, SideNav, SideNavItem } from "react-materialize";
import SparklingChart from "./components/sparklingchart";
import CostChart from "./components/costchart";
import "./index.css";
import * as M from "@materializecss/materialize";
import type { StrategyData } from "./components/sparklingchart";

window.M = M;

ChartJS.register(
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  CategoryScale,
  LogarithmicScale,
  Colors,
  Tooltip,
  Legend,
);
(ChartJS.defaults.animation as { duration: number }).duration = 100;

const STRATEGIES: Record<string, string> = require("./allocations/all.json");
const ALL_STRATEGY_DATA: Record<string, StrategyData> = {};

for (const strategy in STRATEGIES) {
  ALL_STRATEGY_DATA[strategy] = require(`./allocations/${strategy}.json`);
}

interface AppState {
  strategy: string | null;
  day: number;
  darkMode: boolean;
}

class App extends React.Component<object, AppState> {
  constructor(props: object) {
    super(props);
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    this.state = { strategy: "full_order.greedy", day: 1, darkMode: prefersDark };
    document.documentElement.setAttribute("theme", prefersDark ? "dark" : "light");
  }

  toggleTheme = () => {
    const darkMode = !this.state.darkMode;
    this.setState({ darkMode });
    document.documentElement.setAttribute("theme", darkMode ? "dark" : "light");
  };

  render() {
    return (
      <div>
        <Navbar
          className="navbar"
          alignLinks="right"
          brand={<span style={{ paddingLeft: "20px", width: "420px" }}>Order Strategy Dashboard</span>}
          id="mobile-nav"
          menuIcon={<span />}
        >
          <button
            onClick={this.toggleTheme}
            title="Toggle dark/light mode"
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, color: "inherit" }}
          >
            {this.state.darkMode ? "☀️" : "🌙"}
          </button>
        </Navbar>
        <SideNav options={{ draggable: true }} id="cool-sidenav">
          <li id="overview-nav">
            <a onClick={() => this.setState({ strategy: null })} href="#!overview">
              Overview
            </a>
          </li>
          <SideNavItem divider />
          {Object.keys(STRATEGIES).map((key) => (
            <li key={key}>
              <a onClick={() => this.setState({ strategy: key })} href={`#!${key}`}>
                {STRATEGIES[key]}
              </a>
            </li>
          ))}
        </SideNav>
        <Button
          node="button"
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
          }}
          className="hidden-on-desktop menu-trigger"
          onClick={() => window.M.Sidenav.getInstance(document.getElementById("cool-sidenav")!).open()}
        >
          𓃑
        </Button>
        <main>
          <h4 className={"right-align"}>Welcome to the Order Allocation Dashboard!</h4>
          <p className={"right-align"}>
            This page is autogenerated from GitHub Action runs (automatically performed on push to the repository).
          </p>
          {this.state.strategy !== null ? (
            <div>
              <span style={{ float: "left", fontSize: 18, marginTop: 5 }}>Day:</span>
              <Pagination
                activePage={1}
                items={15}
                leftBtn={"‹"}
                rightBtn={"›"}
                onSelect={(value) => this.setState({ day: value })}
              />
              {this.state.strategy in ALL_STRATEGY_DATA ? (
                <SparklingChart
                  strategyData={ALL_STRATEGY_DATA[this.state.strategy]}
                  strategy={this.state.strategy}
                  day={this.state.day}
                />
              ) : (
                "Loading"
              )}
            </div>
          ) : (
            <CostChart allStrategyData={ALL_STRATEGY_DATA} />
          )}
        </main>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
